module.exports = __webpack_public_path__ + "img/wapban3.2ef96c53.png";